/* 
 *  This file load-script.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from "@angular/core";

interface Scripts {
    name: string;
    src: string;
    integrity?: string;
}
 // "node_modules/emojionearea/dist/emojionearea.min.js",
              // "node_modules/emojione/lib/js/emojione.min.js",
export const scriptStore: Scripts[] = [
    {name: 'emojionearea', src: 'https://cdnjs.cloudflare.com/ajax/libs/emojionearea/3.4.1/emojionearea.min.js'},
    {name: 'emojione', src: 'https://cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/lib/js/emojione.min.js'},
    {name: 'linkify', src: 'https://cdnjs.cloudflare.com/ajax/libs/jQuery-linkify/2.1.7/linkify.min.js'},
    {name: 'linkifyJquery', src: 'https://cdnjs.cloudflare.com/ajax/libs/jQuery-linkify/2.1.7/linkify-jquery.min.js'},
    {name: 'quill', src: 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.6/quill.min.js'},
    {name: 'chart', src: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.8.0/Chart.min.js'},
    {name: 'highchart', src: 'https://code.highcharts.com/highcharts.js'},
    {name: 'highchartHeatmap', src: 'https://code.highcharts.com/modules/heatmap.js'},
    {name: 'highchartExport', src: 'https://code.highcharts.com/modules/exporting.js'},
    {name: 'leaflet', src: 'https://unpkg.com/leaflet@1.5.1/dist/leaflet.js',
        integrity: 'sha512-GffPMF3RvMeYyc1LWMHtK8EbPv0iNZ8/oTtHPx9/cc2ILxQ+u905qIwdpULaqDkyBKgOaB57QTMg7ztg8Jm2Og=='},
    {name: 'googlePlatform', src: 'https://apis.google.com/js/platform.js'},
    {name: 'msal', src: 'https://alcdn.msauth.net/lib/1.3.0/js/msal.js'},
    {name: 'highchartMore', src: "https://code.highcharts.com/highcharts-more.js"},
    {name: 'gaugeChart', src: "https://code.highcharts.com/modules/solid-gauge.js"},
    {name: 'export', src: "https://code.highcharts.com/modules/export-data.js"},
    {name: 'accessibility', src: "https://code.highcharts.com/modules/accessibility.js"},
    {name: 'summerNoteEditor', src: "https://cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote-lite.min.js"},
    // <name: "text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/7277696.js"></script>
    {name: "hubspot", src:"//js.hs-scripts.com/7277696.js"}
];

declare var document: any;

@Injectable()
export class LoadScriptService {

    private scripts: any = {};

    constructor() {
        scriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }

    load(...scripts: string[]) {
        const promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }

    loadScript(name: string) {
        return new Promise((resolve, reject) => {
            // resolve if already loaded
            if (this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            } else {
                // load script
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                if (this.scripts[name].integrity) {
                    script.integrity = this.scripts[name].integrity;
                }
                if (script.readyState) {  // IE
                    script.onreadystatechange = () => {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            this.scripts[name].loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  // Others
                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }

}
